export default {
  computed: {
    constructionTypeOptions() {
      return [{
        label: this.$t("application-form.existing"),
        value: "existing"
      }, {
        label: this.$t("application-form.new"),
        value: "new"
      }];
    },
    tenureOptions() {
      return [{
        label: this.$t("application-form.freehold"),
        value: "freehold"
      }, {
        label: this.$t("application-form.leasehold"),
        value: "leasehold"
      }, {
        label: this.$t("application-form.condo"),
        value: "condo"
      }];
    },
    unitOfMeasurementOptions() {
      return [{
        label: this.$t("application-form.sqFt"),
        value: "sq-ft"
      }, {
        label: this.$t("application-form.sqM"),
        value: "sq-m"
      }, {
        label: this.$t("application-form.acres"),
        value: "acres"
      }, {
        label: this.$t("application-form.hectares"),
        value: "hectares"
      }];
    },
    propertyStyleOptions() {
      return [{
        label: this.$t("application-form.one-storey"),
        value: "one-storey"
      }, {
        label: this.$t("application-form.bi-level"),
        value: "bi-level"
      }, {
        label: this.$t("application-form.two-storey"),
        value: "two-storey"
      }, {
        label: this.$t("application-form.split-level"),
        value: "split-level"
      }, {
        label: this.$t("application-form.storey-and-a-half"),
        value: "storey-and-a-half"
      }, {
        label: this.$t("application-form.three-storey"),
        value: "three-storey"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    garageSizeOptions() {
      return [{
        label: this.$t("application-form.single-simple"),
        value: "single",
        imgSrc: "../../shared/assets/img/app-flow/ico-single.svg",
        action: "show"
      }, {
        label: this.$t("application-form.double"),
        value: "double",
        imgSrc: "./../shared/assets/img/app-flow/ico-double.svg",
        action: "show"
      }, {
        label: this.$t("application-form.triple"),
        value: "triple",
        imgSrc: "../../shared/assets/img/app-flow/ico-triple.svg",
        action: "show"
      }, {
        label: this.$t("application-form.none"),
        value: "none",
        imgSrc: "../../shared/assets/img/app-flow/ico-none.svg",
        action: "hide"
      }];
    },
    propertyTypeOptions() {
      return [{
        label: this.$t("application-form.detached"),
        value: "detached",
        imgSrc: "../../shared/assets/img/app-flow/ico-detached.svg"
      }, {
        label: this.$t("application-form.semi-detached"),
        value: "semi-detached",
        imgSrc: "../../shared/assets/img/app-flow/ico-semidetached.svg"
      }, {
        label: this.$t("application-form.row-housing"),
        value: "row-housing",
        imgSrc: "../../shared/assets/img/app-flow/ico-rowhousing.svg"
      }, {
        label: this.$t("application-form.duplex-detached"),
        value: "duplex-detached",
        imgSrc: "../../shared/assets/img/app-flow/ico-duplex.svg"
      }, {
        label: this.$t("application-form.apartment-low-rise"),
        value: "apartment-low-rise",
        imgSrc: "../../shared/assets/img/app-flow/ico-apartment.svg"
      }, {
        label: this.$t("application-form.apartment-high-rise"),
        value: "apartment-high-rise",
        imgSrc: "../../shared/assets/img/app-flow/ico-condo.svg"
      }, {
        label: this.$t("application-form.mobile"),
        value: "mobile",
        imgSrc: "../../shared/assets/img/app-flow/ico-mobile.svg"
      }, {
        label: this.$t("application-form.stacked"),
        value: "stacked",
        imgSrc: "../../shared/assets/img/app-flow/ico-other.svg"
      }];
    },
    garageStyleOptions() {
      return [{
        label: this.$t("application-form.attached"),
        value: "attached"
      }, {
        label: this.$t("application-form.detached"),
        value: "detached"
      }];
    },
    heatingTypeOptions() {
      return [{
        label: this.$t("application-form.electric-baseboard"),
        value: "electric-baseboard"
      }, {
        label: this.$t("application-form.forced-air-gas-oil-elec"),
        value: "forced-air-gas-oil-elec"
      }, {
        label: this.$t("application-form.hot-water-heating"),
        value: "hot-water-heating"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    waterInfoOptions() {
      return [{
        label: this.$t("application-form.municipal"),
        value: "municipal"
      }, {
        label: this.$t("application-form.well"),
        value: "well"
      }];
    },
    basicBinaryOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true
      }, {
        label: this.$t("application-form.no"),
        value: false
      }];
    },
    binaryTrueShowsOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true,
        action: "show"
      }, {
        label: this.$t("application-form.no"),
        value: false,
        action: "hide"
      }];
    },
    binaryFalseShowsOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true,
        action: "hide"
      }, {
        label: this.$t("application-form.no"),
        value: false,
        action: "show"
      }];
    },
    sewageTypeOptions() {
      return [{
        label: this.$t("application-form.municipal"),
        value: "municipal"
      }, {
        label: this.$t("application-form.septic"),
        value: "septic"
      }, {
        label: this.$t("application-form.holding-tank"),
        value: "holding-tank"
      }];
    },
    taxResponsibleOptions() {
      return [{
        label: this.$t("application-form.the-applicant"),
        value: "borrower"
      }, {
        label: this.$t("application-form.applicant-bank"),
        value: "lender"
      }];
    },
    rentalIncomeSelectOptions() {
      return [{
        action: "hide",
        label: this.$t("application-form.none"),
        value: "none"
      }, {
        action: "show",
        label: this.$t("application-form.add-perc-to-gross-income"),
        value: "add-perc-to-gross-income"
      }, {
        action: "show",
        label: this.$t("application-form.red-rental-exp-add-bal"),
        value: "red-rental-exp-add-bal"
      }];
    },
    occupancyTypeOptions() {
      return [{
        label: this.$t("application-form.owner-occupied"),
        value: "owner-occupied"
      }, {
        label: this.$t("application-form.owner-occupied-and-rental"),
        value: "owner-occupied-and-rental"
      }, {
        label: this.$t("application-form.rental"),
        value: "rental"
      }, {
        label: this.$t("application-form.second-home"),
        value: "second-home"
      }];
    },
    occupancyActionTypeOptions() {
      return [{
        label: this.$t("application-form.owner-occupied"),
        value: "owner-occupied",
        action: "hide"
      }, {
        label: this.$t("application-form.owner-occupied-and-rental"),
        value: "owner-occupied-and-rental",
        action: "show"
      }, {
        label: this.$t("application-form.rental"),
        value: "rental",
        action: "show"
      }, {
        label: this.$t("application-form.second-home"),
        value: "second-home",
        action: "hide"
      }];
    },
    propertyValueIndexOptions() {
      return [{
        label: this.$t("application-form.purchase-price"),
        value: "P"
      }, {
        label: this.$t("application-form.appraised-value"),
        value: "A"
      }, {
        label: this.$t("application-form.estimated-value"),
        value: "E"
      }];
    }
  }
};